import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export function ProtectedRoute({ children, role }) {
  const { user, loading } = useAuth();

  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="w-8 h-8 border-2 border-petroleum border-t-transparent rounded-full animate-spin" data-testid="auth-loading-spinner" />
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  if (role && user.role !== role) {
    const fallback = user.role === "admin" ? "/admin" : user.role === "super_admin" ? "/superadmin" : "/portal";
    return <Navigate to={fallback} replace />;
  }

  // Sin pago activo (nunca pagó, o quedó en solo lectura por pago fallido/cancelado): no ve
  // nada de la plataforma salvo Facturación, para poder pagar o renovar. Antes que el chequeo
  // de onboarding, porque sin pagar tampoco tiene sentido pedirle completar el perfil.
  if (user.role === "admin" && user.billing_blocked && window.location.pathname !== "/admin/facturacion") {
    return <Navigate to="/admin/facturacion" replace />;
  }

  if (user.role === "admin" && !user.onboarding_completed && window.location.pathname !== "/onboarding") {
    return <Navigate to="/onboarding" replace />;
  }

  return children;
}
